import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import RegistrationTab from "../../HomeSettingPage/RegistrationTab";

const Step4RegistrationOptions = ({
  wizardData,
  setWizardData,
  registrationID,
  settingInfo,
  saveRef,
}) => {
  return (
    <div className="wizard-step-card">
      <h3 className="wizard-step-title">Registration Options</h3>
      <p className="wizard-step-description">
        Set up your registration options including pricing, sibling discounts,
        and zip code verification.
      </p>

      <div className="wizard-info-box" style={{ marginBottom: 24 }}>
        <p>
          <InfoCircleOutlined style={{ marginRight: 8 }} />
          This step is optional for the wizard. You can skip it now and configure
          these settings later using the "Registration" tab in manual mode.
        </p>
      </div>

      {/* Embed the RegistrationTab component */}
      <RegistrationTab
        registrationID={registrationID}
        setRegistrationID={() => {}}
        settingInfo={settingInfo}
        hideActionButtons={true}
        saveRef={saveRef}
      />
    </div>
  );
};

export default Step4RegistrationOptions;
